import { Key } from "react";

import { InputChoiceInputProps, StyledHiddenInput } from ".";

export function InputChoiceInput<Value extends Key>({
  name,
  value,
  active,
  disabled,
  "data-test": dataTest = "input-choice-input",
}: InputChoiceInputProps<Value>) {
  return (
    <StyledHiddenInput
      data-test={dataTest}
      readOnly
      name={name}
      value={value as (typeof StyledHiddenInput)["value"]}
      type="checkbox"
      checked={active}
      disabled={disabled}
      data-checked={active}
    />
  );
}
